import { VALIDATION_MESSAGES, REGEX_PATTERNS } from 'eebac/constants';


const FIELDS = {
    code: {
        type: "input",
        label: "User ID",
        isRequired: true,
        disabled: true
    },
    firstName: {
        type: "input",
        label: "First Name",
        isRequired: true,
        validations: {
            presence: { allowEmpty: false, message: VALIDATION_MESSAGES.REQUIRED },
            length: {
                minimum: 2, maximum: 255
            },
            format: {
                message: VALIDATION_MESSAGES.INVALID_ONLY_ALPHA_ALLOWED,
                pattern: REGEX_PATTERNS.ONLY_ALPHA
            }
        }
    },
    lastName: {
        type: "input",
        label: "Last Name",
        isRequired: true,
        validations: {
            presence: { allowEmpty: false, message: VALIDATION_MESSAGES.REQUIRED },
            length: {
                minimum: 2, maximum: 255
            },
            format: {
                message: VALIDATION_MESSAGES.INVALID_ONLY_ALPHA_ALLOWED,
                pattern: REGEX_PATTERNS.ONLY_ALPHA
            }
        }
    },
    firmName: {
        type: "input",
        label: "Firm Name",
        isRequired: true,
        validations: {
            presence: { allowEmpty: false, message: VALIDATION_MESSAGES.REQUIRED },
            length: {
                minimum: 2, maximum: 255
            },
            format: {
                message: VALIDATION_MESSAGES.INVALID_ONLY_ALPHA_NUMBERS_SPACES_ALLOWED,
                pattern: REGEX_PATTERNS.COMPANY_NAME
            }
        }
    },
    email: {
        type: "input",
        label: "Email",
        isRequired: true,
        disabled: true
    },
    contactPerson: {
        type: "input",
        label: "Contact Person",
        isRequired: true,
        validations: {
            presence: { allowEmpty: false, message: VALIDATION_MESSAGES.REQUIRED },
            length: {
                minimum: 2, maximum: 50
            },
            format: {
                message: VALIDATION_MESSAGES.INVALID_ONLY_ALPHA_SPACES_ALLOWED,
                pattern: REGEX_PATTERNS.ONLY_ALPHA_SPACES
            }
        }
    },
    mobileNumber: {
        type: "input",
        label: "Mobile Number",
        disabled: true,
        isRequired: true
    },
    // alternateMobileNumber: {
    //     type: "input",
    //     label: "Alternate Mobile Number",
    //     validations: {
    //         format: {
    //             message: VALIDATION_MESSAGES.INVALID,
    //             pattern: REGEX_PATTERNS.MOBILE_NUMBER
    //         }
    //     }
    // },
    // landlineNumber: {
    //     type: "input",
    //     label: "Landline Number",
    //     validations: {
    //         format: {
    //             message: VALIDATION_MESSAGES.INVALID,
    //             pattern: REGEX_PATTERNS.LANDLINE_NUMBER
    //         }
    //     }
    // },
    websiteURL: {
        type: "input",
        label: "Website URL",
        validations: {
            url: {
                schemes: ["https", "http"]
            }
        }
    },
    gstNumber: {
        type: "input",
        label: "GST Number",
        toUpperCase: true,
        validations: {
            format: {
                message: VALIDATION_MESSAGES.INVALID,
                pattern: REGEX_PATTERNS.GST_NUMBER
            }
        }
    },
    firmType: {
        type: "select",
        label: "Firm Type",
        isRequired: true,
        options: [],
        isLoading : false,
        validations: {
            presence: { allowEmpty: false, message: VALIDATION_MESSAGES.REQUIRED },
        }
    },
};

export default FIELDS;